import { apiFetch } from '../apiFetch';
import { CivilDate, parts } from './civilTime';

const STORAGE_KEY = 'radio-ai-time-config';
function getLocalUtcOffsetMinutes(){return -new Date().getTimezoneOffset();}
function tenant(){try{return JSON.parse(localStorage.getItem('radio-ai-user')||'{}').id||null;}catch{return null;}}
function key(id){return STORAGE_KEY+':'+id;}
function normalizeConfig(config={}){const n=Number(config.offsetMinutes);return {offsetMinutes:Number.isInteger(n)&&Math.abs(n)<=840?n:getLocalUtcOffsetMinutes(),timezone:config.timezone||'Sistema',customName:config.customName||null,configurationRevision:config.configurationRevision||null,configuration:config.configuration||null};}
function accept(data,id){
  if(tenant()!==id||data.clienteId!==id||!data.success||!data.configurationRevision||!Number.isInteger(data.offsetMinutes))return false;
  const prior=JSON.parse(localStorage.getItem(key(id))||'null');
  if((prior?.configuration?.revision||0)>(data.configuration?.revision||0))return false;
  localStorage.setItem(key(id),JSON.stringify(normalizeConfig(data)));
  window.dispatchEvent(new CustomEvent('radio-ai-time-config-changed',{detail:{clienteId:id}}));return true;
}
export const timeManager={
  getConfig(){const id=tenant();try{const raw=id&&localStorage.getItem(key(id));if(raw)return normalizeConfig(JSON.parse(raw));}catch{}return normalizeConfig();},
  async saveConfig(config){
    const id=tenant();if(!id)return false;
    try{
      if(!this.getConfig().configurationRevision&&!(await this.syncFromBackend()))return false;
      if(tenant()!==id)return false;
      const res=await apiFetch('/api/time-offset',{method:'POST',body:JSON.stringify({offsetMinutes:Number(config.offsetMinutes),timezone:config.timezone||'Customizado',expectedRevision:this.getConfig().configurationRevision})});
      return res.ok&&accept(await res.json(),id);
    }catch{return false;}
  },
  async syncFromBackend(){const id=tenant();if(!id)return false;try{const res=await apiFetch('/api/time-offset');return res.ok&&accept(await res.json(),id);}catch{return false;}},
  getAdjustedTime(instant=new Date()){return new CivilDate(instant,this.getConfig().offsetMinutes);},
  getCivilParts(instant=new Date()){return parts(instant,this.getConfig().offsetMinutes);},
  getFormattedTime(format = '24h') {
    const time = this.getAdjustedTime();
    const hours = time.getHours();
    const minutes = time.getMinutes();
    
    if (format === '12h') {
      const period = hours >= 12 ? 'PM' : 'AM';
      const hours12 = hours % 12 || 12;
      return `${hours12}:${String(minutes).padStart(2, '0')} ${period}`;
    }
    
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  },

  /**
   * Obter período do dia ajustado
   */
  getPeriod() {
    const time = this.getAdjustedTime();
    const hour = time.getHours();
    
    if (hour >= 5 && hour < 12) return 'manhã';
    if (hour >= 12 && hour < 18) return 'tarde';
    if (hour >= 18 && hour < 22) return 'noite';
    return 'madrugada';
  },

  /**
   * Obter dia da semana ajustado
   */
  getDayOfWeek() {
    const dias = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 
                  'Quinta-feira', 'Sexta-feira', 'Sábado'];
    return dias[this.getAdjustedTime().getDay()];
  },

  /**
   * Presets de fusos horários brasileiros
   */
  getTimezonePresets() {
    return [
      { name: 'Sistema', offset: getLocalUtcOffsetMinutes(), description: 'Usar hora do computador' },
      { name: 'Acre (AC)', offset: -300, description: 'UTC-5 (Rio Branco)' },
      { name: 'Amazonas/MT (UTC-4)', offset: -240, description: 'UTC-4 (Manaus, Cuiabá)' },
      { name: 'Brasília (DF)', offset: -180, description: 'UTC-3 (Hora oficial)' },
      { name: 'Fernando de Noronha', offset: -120, description: 'UTC-2' }
    ];
  },

  /**
   * Calcular offset entre dois fusos
   */
  calculateOffset(fromTimezone, toTimezone) {
    const presets = this.getTimezonePresets();
    const from = presets.find(p => p.name === fromTimezone);
    const to = presets.find(p => p.name === toTimezone);
    
    if (from && to) {
      return to.offset - from.offset;
    }
    
    return 0;
  },

  /**
   * Resetar para hora do sistema
   */
  async reset() {
    return this.saveConfig({
      offsetMinutes: getLocalUtcOffsetMinutes(),
      timezone: 'Sistema',
      customName: null,
    });

  }
};
